// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__mg635","info":"PatientInfo_info__i3eAX"};